/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '#primary-nav' ).slideToggle();
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      $( document ).on( 'click', '.js-init-video', function( e ) {
        e.preventDefault();
        const title = $( e.target ).data( 'title' );
        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
          },
          type: 'iframe',
          mainClass: 'mfp-fade',
          focus: '.mfp-close',
          closeBtnInside: true,
          autoFocusLast: true,
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              // get the current instance of the magnificPopup
              const currentMagnificPopup = $.magnificPopup.instance;

              // add title to the container aria label
              currentMagnificPopup.contentContainer.attr( 'role', 'dialog' );

              if ( title !== undefined ) {
                // get the current iframe element
                const currIframe = currentMagnificPopup.currTemplate.iframe.find( 'iframe' );
                // add title to the iframe and container
                currIframe.prop( 'title', title );
                currentMagnificPopup.contentContainer.attr( 'aria-label', `${title} player` );
              }

              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* Disable duplicate entries on form submit */
      $( function() {
        $( document ).on( 'submit', '.form-skin', function() {
          // Disable submit button
          $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
        } );
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).on( 'change', function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      // increment quantity
      $( 'body' ).on( 'click', '.increment-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).parent( '.llwc-quantity' ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const maxVal = parseInt( qtyInput.attr( 'max' ) );
        if ( !isNaN( maxVal ) && currentVal >= maxVal ) {
          return;
        }
        qtyInput.val( currentVal + 1 );
        $( '[name=update_cart]' ).prop( {'disabled': false, 'aria-disabled': false} );
      } );

      // decrement quantity
      $( 'body' ).on( 'click', '.decrement-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).parent( '.llwc-quantity' ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const minVal = parseInt( qtyInput.attr( 'min' ) );
        if ( currentVal <= minVal ) {
          return;
        }
        qtyInput.val( currentVal - 1 );
        $( '[name=update_cart]' ).prop( {'disabled': false, 'aria-disabled': false} );
      } );

      function openActiveFilters() {
        console.log( 'fired' );
        document.querySelectorAll( '.search-filter-field' ).forEach( ( field ) => {
          const label = field.querySelector( '.search-filter-label' );
          const panel = field.querySelector( '.search-filter-field__input' );

          if ( field.querySelector( '.search-filter-input-checkbox--is-active' ) && label ) {
            // Only trigger click if not already expanded
            if ( label.getAttribute( 'aria-expanded' ) === 'false' ) {
              label.click(); // simulate a user click to open the dropdown
            }
          }
        } );
      }
      setTimeout( openActiveFilters, 10 );

      $( document ).on( 'click', '#print-cart', function() {
        const $cartRows = $( '.shop_table.cart tbody tr.cart_item:visible' );

        if ( $cartRows.length === 0 ) {
          alert( 'Your cart appears empty.' );
          return;
        }

        let cartContent = `
        <h2>Your Cart</h2>
        <table style="width:100%; border-collapse:collapse; font-family: Arial, sans-serif;">
            <thead>
                <tr>
                    <th style="border:1px solid #ccc; padding:5px;">Image</th>
                    <th style="border:1px solid #ccc; padding:5px;">Product</th>
                    <th style="border:1px solid #ccc; padding:5px;">Qty</th>
                    <th style="border:1px solid #ccc; padding:5px;">Price</th>
                    <th style="border:1px solid #ccc; padding:5px;">Total</th>
                </tr>
            </thead>
            <tbody>
    `;

        let subtotal = 0;

        $cartRows.each( function() {
          const $row = $( this );

          // Grab the product name from <a> inside .product-name
          const $productLink = $row.find( '.product-name a' );
          const productName = $productLink.text().trim();
          if ( !productName ) return;

          const img = $row.find( '.product-thumbnail img' ).attr( 'src' ) || '';

          const qty = parseInt( $row.find( '.product-quantity input.qty' ).val() ) || 1;

          const priceText = $row.find( '.product-price .woocommerce-Price-amount' ).first().text().trim();
          const lineTotalText = $row.find( '.product-subtotal .woocommerce-Price-amount' ).first().text().trim();

          // Parse numeric values
          const price = parseFloat( priceText.replace( /[^0-9.-]/g, '' ) ) || 0;
          const lineTotal = parseFloat( lineTotalText.replace( /[^0-9.-]/g, '' ) ) || price * qty;
          subtotal += lineTotal;

          cartContent += `
            <tr>
                <td style="border:1px solid #ccc; padding:5px;">${img ? `<img src="${img}" width="50" />` : ''}</td>
                <td style="border:1px solid #ccc; padding:5px;">${productName}</td>
                <td style="border:1px solid #ccc; padding:5px;">${qty}</td>
                <td style="border:1px solid #ccc; padding:5px;">${priceText}</td>
                <td style="border:1px solid #ccc; padding:5px;">${lineTotalText}</td>
            </tr>
        `;
        } );

        cartContent += `
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="4" style="border:1px solid #ccc; padding:5px; text-align:right;"><strong>Subtotal:</strong></td>
                    <td style="border:1px solid #ccc; padding:5px;">$${subtotal.toFixed( 2 )}</td>
                </tr>
            </tfoot>
        </table>
    `;

        const printWindow = window.open( '', '', 'height=600,width=800' );
        printWindow.document.write( '<html><head><title>Cart</title></head><body>' );
        printWindow.document.write( cartContent );
        printWindow.document.write( '</body></html>' );
        printWindow.document.close();
        printWindow.print();
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
